import axios from "axios";
import Qs from "qs";
import { getToken, getEncodePath } from "./index";
import { HttpStatusType } from "@common/enums/base";
import { redirectToLoginPageWithReturnUrl } from "@common/utils/index";
import objectAssignDeep from "@common/utils/objectAssignDeep";
import Cookies from "js-cookie";
import { initUserProperties, sendAmplitudeLogEvent } from "one-amplitude";
// export const baseURL = isDevelopment() ? "http://localhost:3003/" : "/";
export var baseURL = "/";
export var Api = {
    axios: axios.create({
        withCredentials: true,
        baseURL: baseURL,
        headers: {
            "Content-Type": "application/json; charset=utf-8"
        }
    }),
    header: function (types) {
        var header = { headers: {} };
        if (types.some(function (type) { return type === "formdata"; })) {
            header = objectAssignDeep(header, Api.withForm);
        }
        if (types.some(function (type) { return type === "xhr"; })) {
            header = objectAssignDeep(header, Api.withAspIsAjax);
        }
        if (types.some(function (type) { return type === "accept"; })) {
            header = objectAssignDeep(header, Api.withAccept);
        }
        return header;
    },
    withForm: {
        transformRequest: function (data) { return Qs.stringify(data); },
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    },
    cancelRepsoneAutoParse: {
        transformResponse: function (data, headers) {
            if (typeof data === "string" && headers["content-type"] === "application/json") {
                try {
                    // tslint:disable-next-line:no-parameter-reassignment
                    data = JSON.parse(data);
                }
                catch (e) {
                    /* Ignore */
                }
            }
            return data;
        }
    },
    withAccept: {
        headers: {
            Accept: "*/*"
        }
    },
    withAspIsAjax: {
        headers: {
            "X-Requested-With": "XMLHttpRequest"
        }
    }
};
Api.axios.interceptors.request.use(function (config) {
    var token = getToken();
    if (token) {
        config.headers.Authorization = "Bearer " + getToken();
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});
Api.axios.interceptors.response.use(function (response) {
    if (typeof response.data === "string" && response.data.includes("location.href")) {
        var ignorePages = ['/emailToSchedule/tokenExpired', '/emailToSchedule/unableSchedule',
            '/ResidentScheduleOptimization/EmailToSchedule/tokenExpired',
            '/ResidentScheduleOptimization/EmailToSchedule/unableSchedule',
            '/ResidentScheduleOptimization/EmailToSchedule/noTechnician',
            '/ResidentScheduleOptimization/EmailToSchedule/timeApproaching',
            '/ResidentScheduleOptimization/EmailToSchedule',
            '/ResidentScheduleOptimization/success'];
        if (!ignorePages.some(function (x) { return location.href.includes(x); })) {
            new Function(response.data).call(null);
        }
    }
    if (response.status === HttpStatusType.Unauthorized) {
        var path = getEncodePath();
        if (path) {
            redirectToLoginPageWithReturnUrl();
            return Promise.reject("401");
        }
    }
    if (response &&
        response.data &&
        typeof response.data === "string" &&
        response.data.indexOf("<!DOCTYPE html>") !== -1 &&
        response.data.indexOf('type="password"') !== -1) {
        redirectToLoginPageWithReturnUrl();
        return Promise.reject("Cookie expires");
    }
    return response;
}, function (error) {
    if (error && error.response && error.response.status === 302) {
        return Promise.resolve(error);
    }
    return Promise.reject(error);
});
export var Q = function (axiosPromise) {
    return new Promise(function (resolve, reject) {
        axiosPromise
            .then(function (response) { return resolve(response.data); })
            .catch(function (error) {
            console.warn("Q function error: " + error);
            reject(error);
        });
    });
};
export var uploadFile = function (file) {
    if (!file || !(file instanceof File))
        throw new Error("invalid file!");
    var formData = new FormData();
    formData.append("file", file, file.name);
    return Api.axios.post("/RSP/File/UploadRSP", formData);
};
var isAmplitudeInit = false;
export var sendAmplitude = function (currentUser, logEvent, diffSeconds, attachmentslength) {
    var projectName = "Default";
    var clientId = Cookies.get("clientId");
    initUserProperties("explaintion", currentUser, projectName);
    initUserProperties("userId", currentUser.userId, projectName);
    initUserProperties("fullName", currentUser.fullName, projectName);
    initUserProperties("locationNumber", currentUser.locationNumber);
    initUserProperties("clientId", clientId);
    initUserProperties("staySeconds", diffSeconds);
    initUserProperties("woAttachmentslength", attachmentslength);
    sendAmplitudeLogEvent(logEvent, {}, projectName);
};
export var initCollectApiInfo = function (axios) {
    axios.interceptors.request.use(function (config) {
        // var patt = /(http:\/\/|https:\/\/|\/\/)([\w.]+\/?)\S*/;
        // var isCors = patt.test(config.url);
        // if (!isCors || (isCors && config.url.indexOf(".lessen.com") > -1)) {
        //     var href = window.parent === window ? window.location.href : window.parent.location.href;
        //     config.headers = { ...config.headers, "CUSTOM-APIPATH": JSON.stringify({ href:href }) };
        // }
        return config;
    }, function (error) {
        return Promise.reject(error);
    });
};
export default Api.axios;
